import { computed, ref, watch, watchEffect } from 'vue';
import { useStore } from '@/store/index'
import FuncoesHelper from '@/helpers/FuncoesHelper';
import Rotas from '@/router/Rotas';
import { useRoute } from 'vue-router';
import EtapasComponentesConstant from '@/constants/EtapasComponentesConstant';

class EtapasService {
    setup() {
        const store = useStore()
        const route = useRoute()
        const exibirLoader = ref(false)

        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'))
        const localRealizacao = ref(FuncoesHelper.obterParametrosRota('localRealizacao'))
        const modulo = ref(FuncoesHelper.obterParametrosRota('modulo'))
        const etapaAtual = ref(FuncoesHelper.obterParametrosRota('etapa'))

        const checklistFinalizado = computed(() => store.state.recebimentoFinalizado)
        const modulos = computed(() => store.state.modulos)

        const totalEtapas = ref(0)
        const dadosComponentes = ref({})
        const componentesEtapa = ref([])
        const dadosRespostas = ref({})

        watch(route, () => {
            identificador.value = route.params.identificador
            localRealizacao.value = route.params.localRealizacao
            modulo.value = route.params.modulo
            etapaAtual.value = route.params.etapa

            if (etapaAtual.value > dadosComponentes.value.length) {
                FuncoesHelper.pushRouter(Rotas.ETAPAS.nome, { identificador: identificador.value, etapa: 1 })
            }
            if (checklistFinalizado.value == 'S') {
                FuncoesHelper.pushRouter(Rotas.RESUMO.nome, { identificador: identificador.value })
            }
        })

        watchEffect(() => {
            if (modulos.value) {
                const moduloAtual = modulos.value.find(module => module.idChecklistModulo == modulo.value)
                if (moduloAtual) {
                    dadosComponentes.value = moduloAtual.etapas.componentes
                    for (let etapa in dadosComponentes.value) {
                        const componenteEtapa = dadosComponentes.value[etapa]
                        for (let subkey in componenteEtapa) {
                            const subcomponente = componenteEtapa[subkey]
                            const etapas = EtapasComponentesConstant.ETAPAS;
                            const etapaChave = subcomponente.chave;
                            if (etapas && etapas[etapaChave]) {
                                if (!componentesEtapa.value.some((item) => item.chave === etapaChave)) {
                                    componentesEtapa.value.push({
                                        etapa,
                                        chave: etapaChave,
                                        ...etapas[etapaChave],
                                    });
                                }
                            } else {
                                subcomponente.componenteMenu.forEach((componenteMenu) => {
                                    if (!componentesEtapa.value.some((item) => item.chave === componenteMenu)) {
                                        if (etapas && etapas[componenteMenu]) {
                                            componentesEtapa.value.push({
                                                etapa,
                                                chave: componenteMenu,
                                                ...etapas[componenteMenu],
                                            });
                                        }
                                    }
                                });
                            }
                        }
                    }
                }

            }
        })

        return {
            etapaAtual,
            identificador,
            localRealizacao,
            modulo,
            exibirLoader,
            dadosComponentes,
            dadosRespostas,
            totalEtapas,
            componentesEtapa
        }
    }
}

export default new EtapasService()